const STORAGE_KEY = 'gl-cpf-cache';

type CpfCache = Record<string, string>;

function loadCache(): CpfCache {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}') as CpfCache;
  } catch {
    return {};
  }
}

function saveCache(cache: CpfCache): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(cache));
  } catch {
    /* storage indisponível/cheio — ignora */
  }
}

function buildKey(policyId: string, name: string, dateOfBirth: string): string {
  return `${policyId}|${(name || '').trim().toUpperCase()}|${dateOfBirth || ''}`;
}

export function rememberMemberCpf(
  policyId: string,
  member: { name: string; dateOfBirth: string; cpf?: string },
): void {
  const cpf = (member.cpf || '').trim();
  if (!policyId || !cpf || cpf.includes('*')) return;
  const cache = loadCache();
  cache[buildKey(policyId, member.name, member.dateOfBirth)] = cpf;
  saveCache(cache);
}

export function recallMemberCpf(
  policyId: string,
  member: { name: string; dateOfBirth: string },
): string | undefined {
  if (!policyId) return undefined;
  return loadCache()[buildKey(policyId, member.name, member.dateOfBirth)];
}
